export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7983.f4dc1776.jpg";